module.exports = __webpack_public_path__ + "assets/icon-menu-result.e8ba7fe2.svg";